import request from "./request";

const TopicService = {
  GetAllTopics: async (context) => {
    return await request.sendRequest(
      "/topic/all",
      context?.token
    );
  },

  GetTopicById: async (id, context) => {
    return await request.sendRequest(
      `/topic/${id}`,
      context?.token
    );
  },

SaveTopic: async (payload, context) => {
  return await request.sendPostRequest(
    "/topic",
    payload,
    context
  );
},


  SaveTopics: async (payload, context) => {
    return await request.sendPostRequest(
      "/topic/list",
      payload,
      context
    );
  },

  UpdateTopic: async (id, payload, context) => {
    return await request.sendPutRequestWithBody(
      `/topic/${id}`,
      payload,
      context
    );
  },

  DeleteTopic: async (id, context) => {
    return await request.sendDeleteRequest(
      `/topic/${id}`,
      context?.token
    );
  },

  GetAllSubTopics: async (context) => {
    return await request.sendRequest(
      "/subtopic/all",
      context?.token
    );
  },

  GetSubTopicById: async (id, context) => {
    return await request.sendRequest(
      `/subtopic/${id}`,
      context?.token
    );
  },
  GetAllSubTopicsByTopicId: async (topicId, context) => {
  return await request.sendRequest(
    `/subtopic/all/${topicId}`,
    context?.token
  );
},


  SaveSubTopic: async (payload, context) => {
    return await request.sendPostRequest(
      "/subtopic",
      payload,
      context
    );
  },

  SaveSubTopics: async (payload, context) => {
    return await request.sendPostRequest(
      "/subtopic/list",
      payload,
      context
    );
  },

  UpdateSubTopic: async (id, payload, context) => {
    return await request.sendPutRequestWithBody(
      `/subtopic/${id}`,
      payload,
      context
    );
  },

  DeleteSubTopic: async (id, context) => {
    return await request.sendDeleteRequest(
      `/subtopic/${id}`,
      context?.token
    );
  },

  GetAllVideos: async (context) => {
    return await request.sendRequest(
      "/video/all",
      context?.token
    );
  },
  


  GetVideoById: async (id, context) => {
    return await request.sendRequest(
      `/video/${id}`,
      context?.token
    );
  },

  GetAllVideosBySubTopicId: async (subTopicId, context) => {
  return await request.sendRequest(
    `/video/all/${subTopicId}`,
    context?.token
  );
},

  SaveVideo: async (payload, context) => {
    return await request.sendPostRequest(
      "/video",
      payload,
      context
    );
  },

  SaveVideos: async (payload, context) => {
    return await request.sendPostRequest(
      "/video/list",
      payload,
      context
    );
  },

  UpdateVideo: async (id, payload, context) => {
    return await request.sendPutRequestWithBody(
      `/video/${id}`,
      payload,
      context
    );
  },

  DeleteVideo: async (id, context) => {
    return await request.sendDeleteRequest(
      `/video/${id}`,
      context?.token
    );
  },

  GetAllConfig: async (context) => {
    return await request.sendRequest(
      "/config/all",
      context?.token
    );
  },

  GetConfigById: async (id, context) => {
    return await request.sendRequest(
      `/config/all/${id}`,
      context?.token
    );
  },

  GetConfigList: async (id, category, context) => {
    return await request.sendRequest(
      `/config/list/${id}/${category}`,
      context?.token
    );
  },

  GetConfigByType: async (id, category, type, context) => {
    return await request.sendRequest(
      `/config/${id}/${category}/${type}`,
      context?.token
    );
  },

  UpdateConfig: async (id, category, type, payload, context) => {
    return await request.sendPutRequestWithBody(
      `/config/${id}/${category}/${type}`,
      payload,
      context
    );
  },

  DeleteConfig: async (id, category, type, context) => {
    return await request.sendDeleteRequest(
      `/config/${id}/${category}/${type}`,
      context?.token
    );
  },

  GetEmailSettings: async (instanceId, context) => {
    return await request.sendRequest(
      `/config/emailconfig/${instanceId}`,
      context?.token
    );
  },


  GetAllMetadata: async (type, context) => {
    return await request.sendRequest(
      `/metadata/${type}`,
      context?.token
    );
  },

  GetAllMetadataByParentCode: async (type, parent, context) => {
    return await request.sendRequest(
      `/metadata/${type}/${parent}`,
      context?.token
    );
  },
};

export default TopicService;